class Ijewel3D extends HTMLElement {
    constructor() {
      super();
      this.is_setup_enabled = false;
      this.canvas = document.querySelector('.ijewel-3d-popup-container canvas');
      this.lazy_loadingIcon = document.querySelector('.ijewel-3d-popup-container .lazyloading-icon');
      this.colorSwatches = document.querySelectorAll('.ijewel-popup-swatches .swatch-element.metal-color');
      this.shapeSwatches = document.querySelectorAll('.ijewel-popup-swatches .swatch-element.shape');
      this.submitButton = document.querySelector('.ijewel-popup-submit-button button');
      this.productMediaSidebar = document.querySelector('.product-media-sidebar');
      this.submitButton.addEventListener('click', this.onSubmitClick.bind(this));
      this.colorSwatches.forEach(swatch => {
        swatch.addEventListener('click', this.onColorClick.bind(this));
      });
      this.shapeSwatches.forEach(swatch => {
        swatch.addEventListener('click', this.onShapeClick.bind(this));
      });
      this.glbObject = this.getGlbObject() || {};
      // console.log("glbObject", this.glbObject);
      this.defaultLayerConfig = {
        'Metal 01' : 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/1502007White_Gold.pmat',
        'Metal 02' : 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/1502007White_Gold.pmat',
        'Gem 01'   : 'https://cdn.shopify.com/s/files/1/0757/8851/7659/files/wc-center-stone.dmat',    
        'Gem 02'   : 'https://cdn.shopify.com/s/files/1/0757/8851/7659/files/wc-side-diamond.dmat',    
        'Gem 03'   : 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/JD_SS_Diamond_Gem_3.dmat',
        "User Layer 02" : 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/Logo.pmat',
      }
      this.selectedShape = null;
      this.selectedMetalColor = null;
      this.defaultShape = document.querySelector('.product-single__meta .swatch-shape input:checked + label').dataset.handle;
      this.defaultMetalColor = document.querySelector('.product-single__meta .swatch-metal-color input:checked + label').dataset.handle;
      console.log("onload", this.defaultShape, this.defaultMetalColor);
      this.addActiveClassToDefaultSwatches();
      this.selectedShape = this.defaultShape;
      this.baseURL = "https://cdn.shopify.com/s/files/1/0671/7656/2922/files/";
      this.layerConfig = {...this.defaultLayerConfig};
      this.layerMaterialMap = {};
      this.viewer = null;
      this.ground = null;
      this.taa = null;
      this.detailModel = null;
      this.baseShapeGlb = null;
      this.open_3D_button_html = `<div class="open-3d-button" id="open-3d-button">View in 3D</div>`;
      this.productMediaSidebar.insertAdjacentHTML('beforeend', this.open_3D_button_html);
      this.openButton = document.querySelector('.open-3d-button');
      this.openButton.addEventListener('click', this.open3DModel.bind(this));
      this.closeButton = document.querySelector('.ijewel-3d-popup-container .close-button');
      this.closeButton.addEventListener('click', this.close3DModel.bind(this));
      // this.defaultLayerConfig['Metal 01'] = this.updateColor(this.defaultMetalColor);
      this.applyMetalColor(this.defaultLayerConfig,this.defaultMetalColor);
      this.setupViewer(); 
      this.is_setup_enabled = true;
    }
    onSubmitClick(event) {
      event.preventDefault();
      document.querySelector('.product-form__select-setting').click();
    }
    connectedCallback() {
      this.variant_data = subscribe("VARIANT_INFORMATION_CHANGE",this.handle_variant_data_change.bind(this));
    }
    removeActiveClass(buttons) {
      buttons.forEach(button => {
        button.classList.remove('active');
      });
    }
    addActiveClassToDefaultSwatches() {
      this.removeActiveClass(this.shapeSwatches);
      this.removeActiveClass(this.colorSwatches);
      console.log("defaultShape", this.defaultShape, this.defaultMetalColor);
      document.querySelector(`.ijewel-popup-swatches [data-handle="${this.defaultShape}"]`).classList.add('active');
      document.querySelector(`.ijewel-popup-swatches [data-handle="${this.defaultMetalColor}"]`).classList.add('active');
    }
    async setupViewer() {
      this.viewer = new ViewerApp({
        canvas: this.canvas,
      });
      const rootScaleFactor = 1;
      this.viewer.scene.modelRoot.scale.set(rootScaleFactor, rootScaleFactor, rootScaleFactor);
      this.viewer.renderer.displayCanvasScaling = 1.5; 
      await addBasePlugins(this.viewer, { importPopup: false, enableDrop: false });
      await this.viewer.getOrAddPlugin(DiamondPlugin);
      this.viewer.renderer.refreshPipeline();
      this.ground = this.viewer.getPlugin(GroundPlugin);
      this.ground.autoBakeShadows = false;
      this.taa = this.viewer.getPlugin(TemporalAAPlugin);
      // this.taa.pass.passObject.feedBack.set(0.88, 0.97);
      // this.taa = this.viewer.getPlugin(TemporalAAPlugin);
      // console.log("taa", this.taa, this.taa.feedBack);
      // this.taa.feedBack.set(0.88, 0.97)
      this.manager = this.viewer.getManager();
      this.viewer.enabled = false;
      this.lazy_loadingIcon.style.display = 'flex';
      this.detailModel = await this.loadModel(this.glbObject[this.defaultShape]);
      console.log("defaultLayerConfig", this.defaultLayerConfig);
      await this.applyLayerConfig(this.defaultLayerConfig);
      await this.viewer.load("https://cdn.shopify.com/s/files/1/0757/8851/7659/files/WC_Ring_JPG_1.vjson?v=1759919323");
      if (this.manager && this.manager.materials) {
        const allMaterials = this.manager.materials.getAllMaterials(); 
        console.log('All available materials in model:', allMaterials.map(m => m.name));
      }
      this.viewer.enabled = true;
      this.viewer.fitToView();
      this.ground.bakeShadows();
      this.lazy_loadingIcon.style.display = 'none';
    }
    async getOrCreateMaterial(layerName, matName) {
      let material = this.layerMaterialMap[matName];
      if (material !== undefined) {
        return material;
      } else {
        const matURL = matName;
        if (matURL !== undefined) {
          material = await this.viewer.load(matURL);
          material.name = matName;
          this.layerMaterialMap[matName] = material;
          return material;
        } else {
          console.warn('Unable to find material for layer ', layerName);
        }
      }
      // console.log("layerMaterialMap", this.layerMaterialMap);
    }
    async applyMaterialToLayer(layerName, material) {
      const materials = this.manager.materials.findMaterialsByName(layerName);
      if (materials && materials.length > 0) {
        this.manager.materials.applyMaterial(material, layerName);
      } else {
        console.warn('Unable to find matching materials in Layers');
      }
    }
    async applyLayerConfig(layerConfig) {
      console.log("applyLayerConfig", layerConfig);
      for (let layerName in layerConfig) {
        const matName = layerConfig[layerName];
        const material = await this.getOrCreateMaterial(layerName, matName);
        this.applyMaterialToLayer(layerName, material);
      }
      // console.log("layerMaterialMap", this.layerMaterialMap);
    }
    cleanupScene() {
      this.viewer.scene.disposeSceneModels();
      this.manager?.materials?.dispose();
    }
    async loadModel(url) {
      const model = await this.viewer.load(url, { autoScale: true, autoCenter: true });
      return model;
    }
    updateColor(colorValue) {
      if(colorValue.includes('rose')) {
        return 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/1502007Rose_Gold.pmat';
      }
      if(colorValue.includes('white') || colorValue.includes('platinum')) {
        return 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/1502007White_Gold.pmat';
      }
      if(colorValue.includes('yellow')) {
        return 'https://cdn.shopify.com/s/files/1/0671/7656/2922/files/1502007Yellow_Gold.pmat';
      }
    }
    triggerVariantSwatches(value) {
      document.querySelector(`label[data-handle="${value}"]`).click();
    }
    async onColorClick(event) {
      const clickedElement = event.target.closest('.swatch-element.metal-color') || event.target;
      const colorValue = clickedElement.dataset.handle;
      this.removeActiveClass(this.colorSwatches);
      clickedElement.classList.add('active');
      console.log("colorValue", colorValue);
      // if(colorValue.includes('&')) {
      // this.layerConfig['Metal 01'] = this.updateColor(colorValue);
      this.applyMetalColor(this.layerConfig,colorValue);
      await this.applyLayerConfig(this.layerConfig);
      this.selectedMetalColor = colorValue;
      this.triggerVariantSwatches(this.selectedMetalColor);
    }
    async onShapeClick(event) {
      this.lazy_loadingIcon.style.display = 'flex';
      const clickedElement = event.target.closest('.swatch-element.shape') || event.target;
      const shapeValue = clickedElement.dataset.handle;
      this.removeActiveClass(this.shapeSwatches);
      clickedElement.classList.add('active');
      this.cleanupScene();
      console.log("glbObject", this.glbObject, shapeValue, this.glbObject[shapeValue]);
      this.detailModel = await this.loadModel(this.glbObject[shapeValue]);
      await this.applyLayerConfig(this.layerConfig);
      this.selectedShape = shapeValue;
      this.triggerVariantSwatches(this.selectedShape);
      this.lazy_loadingIcon.style.display = 'none';
    }
    async applyMetalColor(selector,colorValue) {
      if(colorValue.includes('white-yellow') || colorValue.includes('white-rose')) {
        selector['Metal 01'] = this.updateColor('white');
        selector['Metal 02'] = this.updateColor(colorValue.split('white-')[1]);
      }else{
        selector['Metal 01'] = this.updateColor(colorValue);
        selector['Metal 02'] = this.updateColor(colorValue);
      }
    }
    async handle_variant_data_change(data) {
      console.log("handle_variant_data_change", data);
      this.defaultShape = data.shape_type.toLowerCase().replace(/\s+/g, "-");
      this.defaultMetalColor = data.metal_color.toLowerCase().replace(/\s+/g, "-");
      this.addActiveClassToDefaultSwatches();
      if(this.defaultShape !== this.selectedShape && this.is_setup_enabled) {
        this.cleanupScene();
        this.detailModel = await this.loadModel(this.glbObject[this.defaultShape]);
        await this.applyMetalColor(this.layerConfig,this.defaultMetalColor);
        // this.layerConfig['Metal 01'] = this.updateColor(this.defaultMetalColor);
        await this.applyLayerConfig(this.layerConfig);
        this.selectedShape = this.defaultShape;
      }
      if(this.defaultMetalColor !== this.selectedMetalColor && this.is_setup_enabled) {
        await this.applyMetalColor(this.layerConfig,this.defaultMetalColor);
        // this.layerConfig['Metal 01'] = this.updateColor(this.defaultMetalColor);
        await this.applyLayerConfig(this.layerConfig);
        this.selectedMetalColor = this.defaultMetalColor;
      }
      if(!this.is_setup_enabled) {
        await this.applyMetalColor(this.defaultLayerConfig,this.defaultMetalColor);
        // this.defaultLayerConfig['Metal 01'] = this.updateColor(this.defaultMetalColor);
      }
    }
    open3DModel() {
      this.classList.add('active');
    }
    close3DModel() {
      this.classList.remove('active');
    }
    getGlbObject() {
      const glbObject = document.getElementById('ijewel-shape-glbs').textContent;
      return JSON.parse(glbObject);
    }
  
  }
  
  customElements.define('ijewel-3d', Ijewel3D);
  